import { render, staticRenderFns } from "./DepartamentTable.vue?vue&type=template&id=6c711905"
import script from "./DepartamentTable.vue?vue&type=script&lang=js"
export * from "./DepartamentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports